module.exports = __webpack_public_path__ + "img/py.b23de865.png";